import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const element = document.querySelector(target);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navItems = [
    { label: "ABOUT", target: "#about" },
    { label: "SERVICE", target: "#services" },
    { label: "STRENGTH", target: "#strengths" },
    { label: "COMPANY", target: "#company" },
    { label: "CONTACT", target: "#contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background/90 backdrop-blur-md border-b border-border/50"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, "#hero")}
            className="flex items-center gap-3"
          >
            <img
              src="https://storage.helloreaddy.io/project_files/67d84fd7-5259-43f2-8b88-812a2bb89269/8312ae00-1c0f-47a3-b040-18487b03ab08_compressed_LOB_logo_white_transparent.webp"
              alt="株式会社LoB"
              className="h-8 md:h-10 w-auto"
            />
            <span className="text-sm md:text-base font-medium tracking-wider text-white whitespace-nowrap">
              LoB
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-10">
            {navItems.map((item) => (
              <a
                key={item.target}
                href={item.target}
                onClick={(e) => handleNavClick(e, item.target)}
                className={`text-xs tracking-[0.2em] transition-all duration-300 hover:text-accent whitespace-nowrap cursor-pointer ${
                  scrolled ? "text-text-secondary" : "text-white/80"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニュー"
          >
            <span
              className={`w-6 h-px bg-white transition-all duration-300 ${
                menuOpen ? "rotate-45 translate-y-[3.5px]" : ""
              }`}
            />
            <span
              className={`w-6 h-px bg-white transition-all duration-300 ${
                menuOpen ? "opacity-0" : ""
              }`}
            />
            <span
              className={`w-6 h-px bg-white transition-all duration-300 ${
                menuOpen ? "-rotate-45 -translate-y-[3.5px]" : ""
              }`}
            />
          </button>
        </div>
      </div>

      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-background/95 backdrop-blur-md border-b border-border/50 transition-all duration-500 overflow-hidden ${
          menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-6 gap-4">
          {navItems.map((item) => (
            <a
              key={item.target}
              href={item.target}
              onClick={(e) => handleNavClick(e, item.target)}
              className="text-sm tracking-[0.2em] text-text-secondary hover:text-accent transition-colors whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}